/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import profileDetailsLabel from "../../../candidatedatamanagement/labels/candidatedatamanagement_en.json";
import "../../styles/candidate_management.css";
import dayjs from 'dayjs';
import { fromUTCDate, dateDiffereceExServiceMan } from "../../../helpers/Datetime";
import { getDropdownOptionLabel, nameOfIndexingBodies, articleType, flgPublicationFirstAuthor, authorType, getLookupOptionLabelNew } from "../../../helpers/LookupOptionHelper";
import { BOOLEAN_OPTION, FULLTIME_OPTION, AUTHOR_TYPES } from '../../../common/constants/dropdownOptions';
import { setProfileCreationDropdown } from '../../../candidatedatamanagement/actions/candidateDataManagementAction';
import applicationstagesLabels from '../labels/applicationstages_en.json'

const ProfileApplicationReport = (props) => {
    const printRef = useRef();
    const dispatch = useDispatch();
    const { getApplicationDetailsForApplicationProfileReport } = useSelector((state) => state.applicationManagementReducer, shallowEqual);
    const { profileCreationAllLookupData, qualificationTypes, nameOfIndexingBodiesList, getPublicationArticleTypeList } = useSelector((state) => state.candidateDataManagementReducer, shallowEqual)
    const defaultImage = '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';
    let publilcationTableCount = 0;

    useEffect(() => {
        dispatch(setProfileCreationDropdown())
        // eslint-disable-next-line
    }, [])
    if ((getApplicationDetailsForApplicationProfileReport.length === 0) || (getApplicationDetailsForApplicationProfileReport == null)) {
        return <div>{profileDetailsLabel.PROFILE_INFO_IS_NOT_LOADED}</div>;
    }
    const {
        requiredStates,
        requiredQualificationNameCode,
        requiredQualificationTypeCodes,
        requiredQualificationUniversityCodes,
        requiredSubject,
        requiredTaluka,
        requiredVillage,
        requiredDistricts,
    } = getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto;


    if (!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo) {
        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo = getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo;
    }

    function getStateName(statecode, stateList) {
        const state = stateList && stateList.find((state) => state.statecode == statecode);
        if (!state) return statecode;
        return state.statename;
    }

    function getDistrict(districtcode, districtList) {
        const district = districtList && districtList.find(
            (district) => district.districtcode == districtcode
        );
        if (!district) return districtcode;
        return district.districtname;
    }

    function getTaluka(talukacode, talukaList) {
        const taluka = talukaList && talukaList.find(
            (taluka) => taluka.subdistrictcode == talukacode
        );
        if (!taluka) return talukacode;
        return taluka.subdistrictname;
    }

    function getVillage(villagecode, villageList) {
        const village = villageList && villageList.find(
            (village) => village.villagecode == villagecode
        );
        if (!village) return villagecode;
        return village.villagename;
    }

    function getQualificationType(qualificationTypecode, qualificationtypeList) {
        const qualification =
            qualificationtypeList &&
            qualificationtypeList.find(
                (qualification) =>
                    qualification.qualificationtypecode == qualificationTypecode
            );

        if (!qualification) return qualificationTypecode;
        return qualification.qualificationtypename;
    }

    function getUniversity(universitycode, universityname) {
        const university = universityname && universityname.find(
            (university) => university.universityCode == universitycode
        );
        if (!university) return universitycode;
        return university.universityName;
    }

    function getSubject(subjectid, subjectname) {
        const subject =
            subjectname &&
            subjectname.find((subject) => subject.subjectId == subjectid);

        if (!subject) return "";
        return subject.subjectName
    }

    function getQualificationNameCode(qualificationnamecode, qualificationnameList) {
        const qualification = qualificationnameList && qualificationnameList.find((qualification) =>
            qualification.qualificationNameCode == qualificationnamecode
        );
        if (!qualification) return qualificationnamecode;
        return qualification.qualificationName;
    }

    function getExServiceManDivision(exServiceManDivision) {
        let exServiceDivision
        if (exServiceManDivision == 'Air_Force') {
            exServiceDivision = "Air Force"
        } else if (exServiceManDivision == 'Gallantry_Award_winners') {
            exServiceDivision = "Gallantry Award winners of Territorial Army"
        }
        else {
            exServiceDivision = exServiceManDivision
        }
        return exServiceDivision
    }

    const getEligibility = (eligibility) => {
        let list = []
        eligibility.forEach((ele, index) => {
            if (ele && index === 0) {
                list.push('A')
            }
            if (ele && index === 1) {
                list.push('B')
            }
            if (ele && index === 2) {
                list.push('C')
            }
            if (ele && index === 3) {
                list.push('D')
            }
        })
        return list.toString()
    }

    const handleFromToDateSelection = (fromdate, todate) => {
        let expYears;
        let expMonths;
        let expDays;
        let difference = dateDiffereceExServiceMan(fromdate, todate);
        expYears = difference.years;
        expMonths = difference.months;
        expDays = difference.days;
        return "Years" + " " + expYears + ", " + "Months   " + " " + expMonths + ", " + "Days" + " " + expDays;
    }

    const handleFromToDateSelectionForExp = (fromdate, todate) => {
        let expYears;
        let expMonths;
        let expDays;
        let difference = dateDiffereceExServiceMan(fromdate, todate);
        expYears = difference.years;
        expMonths = difference.months;
        expDays = difference.days;
        return {
            expYears: expYears,
            expMonths: expMonths,
            expDays: expDays
        }
    }

    const handlePrint = () => {
        const printContents = printRef.current.innerHTML;
        const printContainer = document.createElement('div');
        printContainer.innerHTML = printContents;
        document.body.innerHTML = '';
        document.body.appendChild(printContainer);
        window.print();
        window.location.reload();
    };

    const getMobileMask = (mobileno) => {
        if (mobileno) {
            const mobilenumber = mobileno.toString();
            const maskMobileNumber = mobilenumber.replace(mobilenumber.substring(2, 8), 'XXXXXX')
            return maskMobileNumber
        }
    };
    let additionalQuestionsArr = getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.advertisement && getApplicationDetailsForApplicationProfileReport.application.advertisement.additionalQuestions && JSON.parse(getApplicationDetailsForApplicationProfileReport.application.advertisement.additionalQuestions);

    const additionalAnswersDetails = (id) => {
        let additionalAnswersParseData = getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.additionalAnswers && JSON.parse(getApplicationDetailsForApplicationProfileReport.application.additionalAnswers);
        if (additionalAnswersParseData) {
            if (additionalAnswersParseData.hasOwnProperty(id)) {
                if (additionalAnswersParseData[id] === true || additionalAnswersParseData[id] === "true") {
                    return "Yes"
                } else if (additionalAnswersParseData[id] === false || additionalAnswersParseData[id] === "false") {
                    return "No"
                } else {
                    return additionalAnswersParseData[id];
                }
            }
        }
    };

    const applicationPostData = getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.applicationPostPrefDtoList && getApplicationDetailsForApplicationProfileReport.applicationPostPrefDtoList && getApplicationDetailsForApplicationProfileReport.applicationPostPrefDtoList.filter((e => e.preferredAppointingAuthorities))

    return (
        <div ref={printRef}>
            <div className="row headerSection">
                <div className="col-lg-12 col-md-12 col-12 d-flex mb-2 align-items-center justify-content-center">
                    <img src="/logos/mpsc_pdf_logo.jpg" className="img-fluid blackBorderCss" alt="" width="99%" />
                </div>
            </div>
            {((getApplicationDetailsForApplicationProfileReport) && ((props.interviewPtLetterReportName === 'Application Recommendation'))) &&
                <h4 className="candidateProfileLabelCss mt-2 mb-2">{applicationstagesLabels.APPLICATION_RECOMMENDATION}</h4>
            }
            {((getApplicationDetailsForApplicationProfileReport) && ((props.interviewPtLetterReportName === 'Profile Details'))) &&
                <h4 className="candidateProfileLabelCss mt-2 mb-2">{applicationstagesLabels.PROFILE_DETAILS}</h4>
            }
            {((getApplicationDetailsForApplicationProfileReport && (getApplicationDetailsForApplicationProfileReport.application !== undefined))) &&
                <div className="box-one print_block mt-3 ms-3">
                    <h6 className='customTextStyle'>{profileDetailsLabel.APPLICATION_DETAILS}
                        {(getApplicationDetailsForApplicationProfileReport) && <button id="hide_Block" type="button" className=" btn btn-primary custom_button  btn-sm float-end  " onClick={() => handlePrint()} >{profileDetailsLabel.PRINT}</button>}
                        <div className="clearfix"></div>
                    </h6>
                    <div className="box-contents">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="content-row">
                                    <h6> {profileDetailsLabel.ADVERTISEMENT_NUMBER}:</h6>
                                    {
                                        (getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.advertisement && getApplicationDetailsForApplicationProfileReport.application.advertisement
                                            .advertisementNo)
                                    }/
                                    {
                                        (getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.advertisement && getApplicationDetailsForApplicationProfileReport.application.advertisement
                                            .year)
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="content-row">
                                    <h6> {profileDetailsLabel.APPLICATION_NO}:</h6>
                                    {
                                        getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.applicationNo
                                    }
                                </div>
                            </div>
                        </div>
                        <hr className="mar_top_bottom_8" />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="content-row">
                                    <h6>{profileDetailsLabel.NAME_OF_ADVT_EXAM}</h6>
                                    {
                                        getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.postId && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.postId
                                    }
                                </div>
                            </div>
                        </div>
                        <hr className="mar_top_bottom_8" />
                    </div>
                </div>}
            {((getApplicationDetailsForApplicationProfileReport && (getApplicationDetailsForApplicationProfileReport.application !== undefined))) &&
                <div className="box-one print_block ms-3">
                    <h6 className='customTextStyle'>{profileDetailsLabel.INTERVIEW_DETAILS}<div className="clearfix"></div></h6>
                    <div className="box-contents">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="content-row">
                                    <h6> {profileDetailsLabel.INTERVIEW_NO}</h6>
                                    {
                                        (getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.interview_no && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.interview_no)
                                    }
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="content-row">
                                    <h6> {profileDetailsLabel.ROLL_NO_1}</h6>
                                    {
                                        (getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.roll_No1 && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.roll_No1)
                                    }
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="content-row">
                                    <h6> {profileDetailsLabel.ROLL_NO_2}</h6>
                                    {
                                        (getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.roll_No2 && getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.roll_No2)
                                    }
                                </div>
                            </div>
                        </div>
                        <hr className="mar_top_bottom_8" />
                    </div>
                </div>}
            {((getApplicationDetailsForApplicationProfileReport && (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto !== undefined))) &&
                <div className="advertisement_details_Eligibility border border-light pt-2 pb-2 ps-3">
                    {(props.interviewPtLetterReportName === 'Profile Details') ?
                        <>
                            <div className="card">
                                <div className="card-header">
                                    <span>
                                        {profileDetailsLabel.PROFILE_LABEL}
                                    </span>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <div className="col-md-5 pad_0">
                                            <div className="content-row">
                                                <h6>
                                                    {profileDetailsLabel.FULLNAME_ENGLISH}:
                                                </h6>
                                                <span className="word-break">
                                                    {
                                                        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .englishFullName
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <div className="content-row">
                                                <h6>
                                                    {profileDetailsLabel.FULLNAME_DEVNAGARI}:
                                                </h6>
                                                <span>
                                                    {
                                                        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .devnagariFullName
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-2">
                                            {(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.photo) ?
                                                <img
                                                    alt='/#'
                                                    className="img-profile"
                                                    src={`data:image/png;base64,${getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.photo}`}
                                                    width="130" height="auto" />
                                                :
                                                <img
                                                    alt='/#'
                                                    className="img-profile"
                                                    src={`data:image/png;base64,${defaultImage}`}
                                                    width="130" height="auto" />
                                            }
                                        </div>
                                        <div className="col-md-10">
                                            <div className="row">
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6>
                                                            {profileDetailsLabel.MOTHERS_NAME}:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.motherName}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6>{profileDetailsLabel.DATE_OF_BIRTH}: </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dob ?
                                                                dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dob))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6> {profileDetailsLabel.GENDER}: </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .genderLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 pad_0">
                                                    <hr className="mar_top_bottom_8" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6> {profileDetailsLabel.AGE}: </h6>
                                                        <span>
                                                            {/* {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dob ?
                                                                    calculateAge(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dob)
                                                                    : ""
                                                            } */}
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.ageAsOf ?
                                                                    getApplicationDetailsForApplicationProfileReport.interviewPtCsvDto.ageAsOf
                                                                    : ""
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6> {profileDetailsLabel.NATIONALITY}: </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .nationalityLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6>{profileDetailsLabel.MOTHER_TONGUE}: </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .motherTongueLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 pad_0">
                                                    <hr className="mar_top_bottom_8" />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6>
                                                            {profileDetailsLabel.WHETHER_MARRIED}:
                                                        </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .maritalStatusLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>

{getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId == 329 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.maritalStatusLookupId == 365 && 
                                                    <div className="content-row">
                                                        <h6>
                                                            {profileDetailsLabel.HUSBAND_NAME}:
                                                        </h6>
                                                        <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.husbandName}
                                                        </span>
                                                    </div>
                                                        }
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6>{profileDetailsLabel.MOBILE_NO}: </h6>
                                                        {(props.interviewPtLetterReportName === 'Profile Details') ?
                                                            <span >
                                                                {
                                                                    getMobileMask(
                                                                        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.mobileNumber
                                                                    )
                                                                }
                                                            </span>
                                                            :

                                                            <span >
                                                                {
                                                                    // getMobileMask(
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.mobileNumber
                                                                    // )
                                                                }
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    <div className="content-row">
                                                        <h6> {profileDetailsLabel.Email_ID} : </h6>
                                                        {(props.interviewPtLetterReportName === 'Profile Details') ?
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId.replace(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId.substring(2, 12), 'XXXXXX') : ""}

                                                            </span>
                                                            :
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId : ""}

                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 pad_0">
                                                    <hr className="mar_top_bottom_8" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card mt-4">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.OTHER_DETAILS} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    {(Number(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId) === 322) ?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <hr className="mar_top_bottom_8" />
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.FLG_TRANSGENDER_FEMALE_RADIO_BTN_LABEL}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="content-row clearfix">
                                                <h6 className='d-inline'>{profileDetailsLabel.WHETHER_YOUR_NAME_CHANGED_UPDATES_AFTER_10TH}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNameChanged ? "Yes" : "No"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNameChanged ?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <hr className="mar_top_bottom_8" />
                                                <div className="content-row clearfix">
                                                    <h6 className='d-inline'> {profileDetailsLabel.CHANGED_UPDATED_NAME}: </h6>
                                                    <span className="word-break">
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.changedEnglishName}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}

                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.maritalStatusLookupId == '357' || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.maritalStatusLookupId == '359') ?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <hr className="mar_top_bottom_8" />
                                                <div className="content-row">
                                                    <h6 className='d-inline'>{profileDetailsLabel.CANDIDATE_LIABLE}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgCandidateLiable ? "Yes" : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        : ""
                                    }
                                    <div className="row">
                                        <div className="col-md-12 pad_0">
                                            <hr className="mar_top_bottom_8" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4 pad_0">
                                            <div className="content-row">
                                                <h6>{profileDetailsLabel.READ_MARATHI}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgMarathiRead
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 pad_0">
                                            <div className="content-row">
                                                <h6>
                                                    {profileDetailsLabel.WRITE_MARATHI}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgMarathiWrite
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 pad_0">
                                            <div className="content-row">
                                                <h6>
                                                    {profileDetailsLabel.SPEAK_MARATHI}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgMarathiSpeak
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <div className="card">
                            <div className="card-header">
                                <span>
                                    {profileDetailsLabel.PROFILE_LABEL}
                                </span>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-5 pad_0">
                                        <div className="content-row">
                                            <h6>
                                                {profileDetailsLabel.FULLNAME_ENGLISH}:
                                            </h6>
                                            <span className="word-break">
                                                {
                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .englishFullName
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="content-row">
                                            <h6>
                                                {profileDetailsLabel.FULLNAME_DEVNAGARI}:
                                            </h6>
                                            <span>
                                                {
                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .devnagariFullName
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-2">
                                        {(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.photo) ?
                                            <img
                                                alt='/#'
                                                className="img-profile"
                                                src={`data:image/png;base64,${getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.photo}`}
                                                width="130" height="auto" />
                                            :
                                            <img
                                                alt='/#'
                                                className="img-profile"
                                                src={`data:image/png;base64,${defaultImage}`}
                                                width="130" height="auto" />
                                        }
                                    </div>
                                    <div className="col-md-10">
                                        <div className="row">
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6 >{profileDetailsLabel.SURNAME}: </h6>
                                                    <span className="word-break mt2">
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.surname}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.FIRST_NAME}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.firstName}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.MIDDLE_NAME}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.middleName}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pad_0">
                                                <hr className="mar_top_bottom_8" />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>
                                                        {profileDetailsLabel.MOTHERS_NAME}:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.motherName}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.DATE_OF_BIRTH}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dob ?
                                                            dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dob))).format("DD/MM/YYYY")
                                                            : ""}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                {/* {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.motherTongueLookupId == '356' ?
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.OTHER_LANGUAGES}</h6>
                                                    <span className="word-break">
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.otherLanguages}
                                                    </span>
                                                </div>
                                                : ""} */}
                                                <div className="content-row">
                                                    <h6> {profileDetailsLabel.GENDER}: </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .genderLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pad_0">
                                                <hr className="mar_top_bottom_8" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6> {profileDetailsLabel.NATIONALITY}: </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .nationalityLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.MOTHER_TONGUE}: </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .motherTongueLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>
                                                        {profileDetailsLabel.WHETHER_MARRIED}:
                                                    </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .maritalStatusLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pad_0">
                                                <hr className="mar_top_bottom_8" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.READ_MARATHI}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgMarathiRead
                                                            ? "Yes"
                                                            : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>

                                                        {profileDetailsLabel.WRITE_MARATHI}:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgMarathiWrite
                                                            ? "Yes"
                                                            : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>

                                                        {profileDetailsLabel.SPEAK_MARATHI}:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgMarathiSpeak
                                                            ? "Yes"
                                                            : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pad_0">
                                                <hr className="mar_top_bottom_8" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 pad_0">
                                                <div className="content-row">
                                                    <h6>{profileDetailsLabel.MOBILE_NO}: </h6>
                                                    {(props.interviewPtLetterReportName === 'Profile Details') ?
                                                        <span >
                                                            {
                                                                getMobileMask(
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.mobileNumber
                                                                )
                                                            }
                                                        </span>
                                                        :

                                                        <span >
                                                            {
                                                                // getMobileMask(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.mobileNumber
                                                                // )
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                            <div className="col-md-6 pad_0">
                                                <div className="content-row">
                                                    <h6> {profileDetailsLabel.Email_ID} : </h6>
                                                    {(props.interviewPtLetterReportName === 'Profile Details') ?
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId.replace(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId.substring(2, 12), 'XXXXXX') : ""}

                                                        </span>
                                                        :
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId : ""}
                                                            {/* {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId.replace(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.emailId.substring(2, 12), 'XXXXXX') : ""} */}

                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {(Number(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId) === 322) ?
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <hr className="mar_top_bottom_8" />
                                        <div className="col-md-10 pad_0">
                                            <hr className="mar_top_bottom_8" />
                                            <div className="content-row">
                                                <h6>{profileDetailsLabel.FLG_TRANSGENDER_FEMALE_RADIO_BTN_LABEL}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale ? "Yes" : "No"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="col-md-10 pad_0">
                                        <hr className="mar_top_bottom_8" />
                                        <div className="content-row">
                                            <h6 className='d-inline'>{profileDetailsLabel.WHETHER_YOUR_NAME_CHANGED_UPDATES_AFTER_10TH}: </h6>
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNameChanged ? "Yes" : "No"}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNameChanged ?
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <hr className="mar_top_bottom_8" />
                                        <div className="col-md-10 pad_0">
                                            <hr className="mar_top_bottom_8" />
                                            <div className="content-row">
                                                <h6> {profileDetailsLabel.CHANGED_UPDATED_NAME}: </h6>
                                                <span className="word-break">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.changedEnglishName}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}

                                {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.maritalStatusLookupId == '357' || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.maritalStatusLookupId == '359') ?
                                    <div className="row">
                                        <div className="col-md-2"></div>
                                        <hr className="mar_top_bottom_8" />
                                        <div className="col-md-10 pt-2 pb-2 ps-3">
                                            <hr className="mar_top_bottom_8" />
                                            <div className="content-row">
                                                <h6 className='d-inline'>{profileDetailsLabel.CANDIDATE_LIABLE}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgCandidateLiable ? "Yes" : "No"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    : ""
                                }
                            </div>
                        </div>
                    }
                    <br />

                    {/* Adhar Details */}
                    <div className="card">
                        <div className="card-header">
                            <span> {profileDetailsLabel.FIRST_PROFILE_HEADER} </span>
                        </div>
                        <div className="card-body pad_top_bottom_8">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="content-row clearfix">
                                        <h6>{profileDetailsLabel.Are_YOU_HOLDING_AADHAR_VIEW}: </h6>
                                        <span>
                                            {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo ?
                                                "Yes" : "No"}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-md-12 pad_0">
                                    <hr className="mar_top_bottom_8" />
                                </div>
                                {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo ?
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>{profileDetailsLabel.AADHAR_NO}: </h6>
                                            {(props.interviewPtLetterReportName === 'Profile Details') ?
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo.replace(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo.substring(0, 8), 'XXXXXX') : ""}
                                                </span>
                                                :
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo : ''}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    : ""}
                                {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNo ?
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>{profileDetailsLabel.NAME_IN_ENGLISH}: </h6>
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.aadhaarNameInEnglish}
                                            </span>
                                        </div>
                                    </div>
                                    : ""}
                            </div>
                        </div>
                    </div>
                    <br />

                    {(props.interviewPtLetterReportName === 'Application Recommendation') &&
                        <>
                            {/* physical mesurement */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.PHYSICAL_MESUREMENT} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="content-row clearfix">
                                                <h6>{profileDetailsLabel.HEIGHT}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.height}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="content-row clearfix">
                                                <h6>{profileDetailsLabel.WEIGHT}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.weight}
                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.chestDeflated ?
                                            <div className="col-md-3">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.CHEST_DEFLATED}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .chestDeflated
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            : ""
                                        }
                                        {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.chestInflated ?
                                            <div className="col-md-3">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.CHEST_INFLATED}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .chestInflated
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <br />
                            {/* caste details */}
                            <div className="card">
                                <div className="card-header">
                                    <span>
                                        {profileDetailsLabel.CASTE_CATEGORY_DETAILS}
                                    </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="content-row clearfix">
                                                <h6>{profileDetailsLabel.CATEGORY}: </h6>
                                                <span>
                                                    {getLookupOptionLabelNew(
                                                        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .categoryLookupId,
                                                        profileCreationAllLookupData
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" ?
                                            <>
                                                <div className="col-md-3 pad_0">
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != '332' ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.CASTE_CERTIFICATE_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .castCertificateNo
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""}
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId == '332' && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.ewsCertificateNumber ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.EWS_CASTE_CERTIFICATE_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .ewsCertificateNumber
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {profileDetailsLabel.ISSUING_DISTRICT}:
                                                        </h6>
                                                        <span>
                                                            {getDistrict(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.ccIssuingDistrictLookupId,
                                                                requiredDistricts
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" ?
                                                    <div className="col-md-3 pad_0">
                                                        <div className="content-row clearfix">
                                                            <h6>{profileDetailsLabel.ISSUING_DATE}: </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .castCertiIssuingDate
                                                                    ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castCertiIssuingDate))).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    : ""}
                                            </>
                                            : ""
                                        }
                                    </div>
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "324" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "325" ?
                                        <hr className="mar_top_bottom_8" />
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "324" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "325" ?
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != 323 || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale || (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 320 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 322) ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.DO_YOU_BELONG_TO_NON_CREAMY_LAYER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl
                                                                    ? "Yes"
                                                                    : "No"}
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.nclCertificateNo ?
                                                        <div className="content-row clearfix">
                                                            <h6>{profileDetailsLabel.NCL_CERT_NO}: </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .nclCertificateNo
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                <div className="col-md-4">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.latestNclIssueDate ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {profileDetailsLabel.ISSUING_DATE_NCL}:
                                                            </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .latestNclIssueDate
                                                                    ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.latestNclIssueDate))).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                            </div>
                                            {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl ?
                                                <div>
                                                    {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId == 321 ?
                                                        <div className="content-row clearfix pad_0">
                                                            <hr className="mar_top_bottom_8" />
                                                            &nbsp;&nbsp;<span className="errorText">* {profileDetailsLabel.NOT_CONSIDER_FOR_FEMALE_RESERVATION}: </span>
                                                        </div>
                                                        : ""}
                                                    {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId == 322 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale ?
                                                        <div className="content-row clearfix pad_0">
                                                            <hr className="mar_top_bottom_8" />
                                                            &nbsp;&nbsp;<span className="errorText">* {profileDetailsLabel.NOT_CONSIDER_FOR_FEMALE_RESERVATION}: </span>
                                                        </div>
                                                        : ""
                                                    }
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != 323 || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale || (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 320 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 322) ?
                                                        <div className="content-row clearfix">
                                                            &nbsp;&nbsp;<span className="errorText wordBreakCss">{profileDetailsLabel.YOU_WILL_NOT_BE_CONSIDERED_FOR_RESERVED_CATEGORY_POST}: </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                : ""}

                                        </>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" ?
                                        <hr className="mar_top_bottom_8" />
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" ?
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DO_YOU_HAVE_CASTE_VALIDITY_CERTIFICATE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .flgCastValidityCert
                                                                ? "Yes"
                                                                : "No"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castValidityCertNo ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.CASTE_VALIDITY_CERTIFICATE_NO
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .castValidityCertNo
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                <div className="col-md-4">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castValidityCertIssueDate ?
                                                        <div className="content-row clearfix">
                                                            <h6>{profileDetailsLabel.ISSUING_DATE}: </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .castValidityCertIssueDate
                                                                    ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castValidityCertIssueDate))).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                            </div>
                                        </>
                                        : ""}
                                </div>
                            </div>
                            <br />
                            {/* Divyang details */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.Divyang_Details} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.ARE_YOU_DIVYANGJAN}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.DIVYANG_PERCENTAGE}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .divyangPercentage
                                                        }
                                                    </span>
                                                </div>
                                            </div> : ""}
                                    </div>

                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.CATEGORY_OF_DISABILITIES
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .typeOfDisabilityLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DATE_OF_ISSUE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.sadmCertificateDate ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.sadmCertificateDate))).format('DD/MM/YYYY') : ""
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DISABILITIES_SUB_CATEGORIES
                                                            }:
                                                        </h6>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.disabilitySubCategoriesLookupIds.map((ele, index) => {
                                                            if (ele) {
                                                                return (

                                                                    <span>

                                                                        {getLookupOptionLabelNew(ele, profileCreationAllLookupData)}
                                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.disabilitySubCategoriesLookupIds.length === index + 1 ?
                                                                            <span></span> : <span>,&nbsp;&nbsp;</span>}
                                                                    </span>
                                                                )
                                                            }
                                                        })

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.TYPE_OF_DISABILITY_CERTIFICATE
                                                            }:
                                                        </h6>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.typeDisabilityCertificate === 1 ?
                                                            <span>{profileDetailsLabel.SADM}</span>
                                                            : getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.typeDisabilityCertificate === 2 ?
                                                                <span>{profileDetailsLabel.Swavalamban}</span>
                                                                : ""
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DISABILITY_CERTIFICATE_NUMBER
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.sadmCertificateNumber
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {((getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang) && ((getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid) || (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udidEnrolmentNo))) ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {profileDetailsLabel.DO_YOU_POSSES_UNIQUE_DISABILITY_ID}:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid
                                                                ? "Yes"
                                                                : "No"}
                                                        </span>
                                                    </div>
                                                </div>
                                                {(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid) &&
                                                    <div className="col-md-6">
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.UDID_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                {(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udidEnrolmentNo) &&
                                                    <div className="col-md-6">
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.UDID_ENROLLMENT_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udidEnrolmentNo
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        : ""}
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.DISABILITY_SCRIBE_REQ}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityScribeReq
                                                        ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityScribeReq
                                                        : "---"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.SCRIBE_ARRANGED_BY}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.scribeArrangedBy
                                                        ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.scribeArrangedBy
                                                        : "---"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.DISABILITY_COMP_TIME}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityCompTime
                                                        ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityCompTime
                                                        : "---"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            {/* sports details */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.SPORT_INFORMATION_LABEL.Sports_Details} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="col-md-4">
                                        <div className="content-row clearfix">
                                            <h6>
                                                {profileDetailsLabel.SPORT_INFORMATION_LABEL["ARE_YOU _MERITORIOUS_SPORTS_PERSON?"]}:
                                            </h6>
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                    .flgMetritoriousSportsman
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgMetritoriousSportsman ?
                                    <div className="qualification-table customStyle">
                                        <table className="table table-bordered" >
                                            <thead>
                                                <tr>
                                                    {profileDetailsLabel.sportsHeaderContent && profileDetailsLabel.sportsHeaderContent.slice(0, -2).map((ele, index) =>
                                                        <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className='f12'>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.meritoriousSportsmanDtoList.map((ele, index) => {
                                                    if (ele) {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="w-10 word-break text-center" >{index + 1}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.typeOfCompetitionLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.nameOfCompetitionLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.positionMedalLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{ele.tournamentStartDate ? dayjs(fromUTCDate(new Date(ele.tournamentStartDate))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{ele.tournamentEndDate ? dayjs(fromUTCDate(new Date(ele.tournamentEndDate))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{ele.certificateVerificationStatus === true ? "Yes" : "No"}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.sportsCertiVerificationCityLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{ele.sportsCertiReportNo}</td>
                                                                <td className="word-break" >{ele.dateOfIssue ? dayjs(fromUTCDate(new Date(ele.dateOfIssue))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{ele.acknowledgementNumber}</td>
                                                                <td className="word-break" >{ele.dateOfSubmission ? dayjs(fromUTCDate(new Date(ele.dateOfSubmission))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{getEligibility(ele.eligibleForGroup)}</td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                                }
                                            </tbody>
                                        </table>
                                    </div> : ""}
                            </div>
                            <br />

                            {/* ex-serviceman details */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.exServicemanInfo.Ex_service_Man} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.exServicemanInfo.DOES_EX_SERVICEMAN_OF_THE_REGULAR
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgExArmedReg
                                                        ? "Yes"
                                                        : "No"}

                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.SPORT_INFORMATION_LABEL.DIVISION_OF_ARMED_FORCES
                                                        }:
                                                    </h6>

                                                    <span>
                                                        {getExServiceManDivision(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.exServiceManDivision
                                                        )}
                                                    </span>
                                                </div>
                                            </div> : ""}
                                    </div>
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.DATE_OF_APPOINTMENT_IN_REGULAR_ARMED_FORCES
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateApptArmedRegular
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateApptArmedRegular))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo[
                                                                "DATE_OF_RETIREMEN_(DISCHARGE)_IN_REGULAR_ARMED_FORCES"
                                                                ]
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateRetireArmedRegular
                                                                ?
                                                                dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateRetireArmedRegular)))
                                                                    .format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.PERIOD_OF_SERVICE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {handleFromToDateSelection(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateApptArmedRegular, getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateRetireArmedRegular)
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.DISCHARGE_CERTIFICATE_NUMBER
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .dischargeCertificateNo
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.DATE_OF_DISCHARGE_FROM_ARMED_FORCES
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateDischargeArmedRegular ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateDischargeArmedRegular))).format('DD/MM/YYYY') : ""
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.THE_SERIAL_NUMBER_AUTHORITY_FOR_AGE_RELAXATION
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .ageRelaxCertiNo
                                                            }
                                                        </span>
                                                        <span className='floatRight'> {profileDetailsLabel.DATE} &nbsp;
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .ageRelaxCertiNo1
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.ageRelaxCertiNo1))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.ARE_YOU_DISABILITY_PENSION_HOLDER
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .flgDisabilityPensionHolder ?
                                                                    "Yes" : "No"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.HAVE_YOU_JOIN_STATE_GOVT
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .flgJoinedStateGovt ?
                                                                    "Yes" : "No"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div> : ""}
                                </div>
                            </div>
                            <br />
                            {/* Government employee details */}
                            <div className="card">
                                <div className="card-header">
                                    <span>
                                        {
                                            profileDetailsLabel.GOV_MAH_EMPLOYEE.Government_of_Maharashtra_Employee_Details
                                        }
                                    </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.GOV_MAH_EMPLOYEE.ARE_YOU_EMPLOYEE_GOVERMENT
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgGomEmployee
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgGomEmployee ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.GOV_MAH_EMPLOYEE.Sevaarth_ID
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .sevaarthId
                                                        }
                                                    </span>
                                                </div> : ""}
                                        </div>
                                    </div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.GOV_MAH_EMPLOYEE.ARE_YOU_EMPLOYEE_BMC
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgBmcEmployee
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.GOV_MAH_EMPLOYEE.ARE_YOU_EMPLOYEE_BEST
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgBestEmployee
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            {/* domicile certificate */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.DOMICILE_DETAILS.Domicile_Details} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.Maharashtra_Domicile_Certificate
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgDomicile
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileIssuingDistrict ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.ISSUING_DISTRICT}:
                                                    </h6>
                                                    <span>
                                                        {getDistrict(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .domicileIssuingDistrict,
                                                            requiredDistricts
                                                        )}

                                                    </span>
                                                </div>
                                                : ""}
                                            {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicile && (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                .flgExArmedReg) ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.DOMICILE_DETAILS.FLG_BORDER_AREA_RADIO_BTN_LABEL}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .flgMaharashtraKarnatakBorderArea ?
                                                                "Yes" : "No"
                                                        }
                                                    </span>
                                                </div>
                                                : ""}
                                        </div>
                                    </div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6 pe-0">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicile ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.DOMICILE_CERTIFICATE_NO
                                                        }:
                                                    </h6>

                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgDomicileCertificate ?
                                                            "Yes" : "No"
                                                        }
                                                    </span >
                                                </div>
                                                : ""}
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.borderDistrictLookupId ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.DOMICILE_DETAILS.BORDER_AREA_DISTRICTS_LABEL
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .borderDistrictLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                                : ""}
                                        </div>
                                        <div className="col-md-6">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicileCertificate && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileCertificateNo ?
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.CERTIFICATE_NUMBER}:</h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .domicileCertificateNo
                                                        }
                                                    </span>
                                                </div>
                                                : ""}

                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.borderTalukaLookupId ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.DOMICILE_DETAILS.BORDER_AREA_TALUKAS_LABEL
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .borderTalukaLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                                : ""}
                                        </div>
                                    </div>

                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicile && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileIssuingDate ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DOMICILE_ISSUING_DATE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .domicileIssuingDate
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileIssuingDate))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}

                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.borderVillageLookupId ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">

                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DOMICILE_DETAILS.BORDER_AREA_VILLAGES_LABEL
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .borderVillageLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                </div>
                            </div>
                            <br />
                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isAdditionalReservation != '' ?
                                <div className="advertisement_details_Eligibility border border-light">
                                    <div className="card">
                                        <div className="card-header">
                                            <span> {profileDetailsLabel.additional_reservation} </span>
                                        </div>
                                        <div className="card-body pad_top_bottom_8">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isProjectAffected ?
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                {
                                                                    profileDetailsLabel.project_affected
                                                                }
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.certificate_number
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.certificateNoPa}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.issuing_date
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDatePa ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDatePa))).format("DD/MM/YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }

                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isEarthquakeAffected ?
                                                <>
                                                    <hr className="mar_top_bottom_8" />
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                {
                                                                    profileDetailsLabel.earthquake_affected
                                                                }
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.certificate_number
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.certificateNoEqa}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.issuing_date
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateEqa ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateEqa))).format("DD/MM/YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isGraduateEmployee ?
                                                <>
                                                    <hr className="mar_top_bottom_8" />
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                {
                                                                    profileDetailsLabel.graduate_employee
                                                                }
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.employee_number
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.employmentNoGpte}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.issuing_date
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateGpte ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateGpte))).format("DD/MM/YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                                : <div className="advertisement_details_Eligibility border border-light">
                                    <div className="card">
                                        <div className="card-header">
                                            <span> {profileDetailsLabel.additional_reservation} </span>
                                        </div>
                                        <div className="card-body pad_top_bottom_8">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <strong>{profileDetailsLabel.additional_reservation}?</strong> : {profileDetailsLabel.BUTTON_NO}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <br />
                            {/* orphan details */}
                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo ?
                                <div className="card">
                                    <div className="card-header">
                                        <span> {profileDetailsLabel.ORPHAN_DETAILS.Orphan_Detail} </span>
                                    </div>
                                    <div className="card-body pad_top_bottom_8">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.ORPHAN_DETAILS.DO_YOU_WANT_TO_TAKE_ADVANTAGE_FOR_ORPHAN_RESERVATION
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgOrphanReservation
                                                            ? "Yes"
                                                            : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgOrphanReservation ?
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.ORPHAN_DETAILS.ORPHAN_TYPE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .orphanType
                                                            }
                                                        </span>
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <hr className="mar_top_bottom_8" />
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgOrphanReservation ?
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.ORPHAN_DETAILS.ORPHAN_CERTIFICATE_NO
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .orphanReservationCertiNo
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.ORPHAN_DETAILS.ORPHAN_CERTIFICATE_ISSUE_DATE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .orphanCertiIssueDate
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.orphanCertiIssueDate))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div> : ""
                                        }
                                    </div>
                                </div>
                                : ""}
                            <br />
                            <div className="advertisement_details_Eligibility border border-light">
                                <label className="fw-bold">
                                    {profileDetailsLabel.profileadressinformation.ADD_INFO}
                                </label>
                                <hr />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <span>

                                                    {
                                                        profileDetailsLabel.profileadressinformation.PERMENANT_ADDRESS
                                                    }
                                                </span>
                                            </div>
                                            <div className="card-body pad_top_bottom_8">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_1
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantHouseNo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_2
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantBuildingName
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_3
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantRoadOrPo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.LANDMARK}: </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantLandmark
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.STATE_UNION_TERRITORY
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getStateName(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantStateLookupId,
                                                            requiredStates
                                                        )}

                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.DISTRICT}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantDistrictLookupId ?
                                                        <span className="word-break">
                                                            {getDistrict(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .permenantDistrictLookupId,
                                                                requiredDistricts
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantDistrict
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                                {/* <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.TALUKA}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantTalukaLookupId ?
                                                        <span className="word-break">
                                                            {getTaluka(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.
                                                                    permenantTalukaLookupId,
                                                                requiredTaluka
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantTaluka
                                                            }
                                                        </span>
                                                    }
                                                </div> */}
                                                {/* <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.profileadressinformation.VILLAGE_CITY}:
                                                    </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantvillageCityLookupId ?
                                                        <span className="word-break">
                                                            {getVillage(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .permenantvillageCityLookupId,
                                                                requiredVillage
                                                            )}
                                                        </span>
                                                        :
                                                        <span className="word-break">
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantvillageCity
                                                            }
                                                        </span>
                                                    }
                                                </div> */}
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.PINCODE}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantPin}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <span>
                                                    {
                                                        profileDetailsLabel.profileadressinformation.CORRESPONDANCE_ADDRESS
                                                    }
                                                </span>
                                            </div>
                                            <div className="card-body pad_top_bottom_8">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_1
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceHouseNo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_2
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceBuildingName
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_3
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceRoadOrPo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.LANDMARK}: </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceLandmark
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.STATE_UNION_TERRITORY
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getStateName(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceStateLookupId,
                                                            requiredStates
                                                        )}
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.DISTRICT}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceDistrictLookupId ?
                                                        <span className="word-break">
                                                            {getDistrict(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .correspondenceDistrictLookupId,
                                                                requiredDistricts
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceDistrict}
                                                        </span>
                                                    }
                                                </div>
                                                {/* <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.TALUKA}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceTalukaLookupId ?
                                                        <span className="word-break">
                                                            {getTaluka(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .correspondenceTalukaLookupId,
                                                                requiredTaluka
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceTaluka}
                                                        </span>
                                                    }
                                                </div> */}
                                                {/* <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.profileadressinformation.VILLAGE_CITY}:
                                                    </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceVillageCityLookupId ?
                                                        <span className="word-break">
                                                            {getVillage(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .correspondenceVillageCityLookupId,
                                                                requiredVillage
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceVillage}
                                                        </span>
                                                    }
                                                </div> */}
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.PINCODE}: </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondencePin
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </>
                    }

                    {(props.interviewPtLetterReportName === 'Profile Details') &&
                        <>
                            {/* domicile certificate */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.DOMICILE_DETAILS.Domicile_Details} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.Maharashtra_Domicile_Certificate
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgDomicile
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileIssuingDistrict ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.ISSUING_DISTRICT}:
                                                    </h6>
                                                    <span>
                                                        {getDistrict(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .domicileIssuingDistrict,
                                                            requiredDistricts
                                                        )}

                                                    </span>
                                                </div>
                                                : ""}
                                            {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicile && (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                .flgExArmedReg) ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.DOMICILE_DETAILS.FLG_BORDER_AREA_RADIO_BTN_LABEL}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .flgMaharashtraKarnatakBorderArea ?
                                                                "Yes" : "No"
                                                        }
                                                    </span>
                                                </div>
                                                : ""}
                                        </div>
                                    </div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6 pe-0">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicile ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.DOMICILE_CERTIFICATE_NO
                                                        }:
                                                    </h6>

                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgDomicileCertificate ?
                                                            "Yes" : "No"
                                                        }
                                                    </span >
                                                </div>
                                                : ""}
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.borderDistrictLookupId ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.DOMICILE_DETAILS.BORDER_AREA_DISTRICTS_LABEL
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .borderDistrictLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                                : ""}
                                        </div>
                                        <div className="col-md-6">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicileCertificate && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileCertificateNo ?
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.CERTIFICATE_NUMBER}:</h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .domicileCertificateNo
                                                        }
                                                    </span>
                                                </div>
                                                : ""}

                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.borderTalukaLookupId ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.DOMICILE_DETAILS.BORDER_AREA_TALUKAS_LABEL
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getLookupOptionLabelNew(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .borderTalukaLookupId,
                                                            profileCreationAllLookupData
                                                        )}
                                                    </span>
                                                </div>
                                                : ""}
                                        </div>
                                    </div>

                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDomicile && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileIssuingDate ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DOMICILE_ISSUING_DATE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .domicileIssuingDate
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.domicileIssuingDate))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}

                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.borderVillageLookupId ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">

                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DOMICILE_DETAILS.BORDER_AREA_VILLAGES_LABEL
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .borderVillageLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                </div>
                            </div>
                            <br />

                            {/* Additional Reservation */}
                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isAdditionalReservation != '' ?
                                <div className="advertisement_details_Eligibility border border-light">
                                    <div className="card">
                                        <div className="card-header">
                                            <span> {profileDetailsLabel.additional_reservation} </span>
                                        </div>
                                        <div className="card-body pad_top_bottom_8">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isProjectAffected ?
                                                <>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                {
                                                                    profileDetailsLabel.project_affected
                                                                }
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.certificate_number
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.certificateNoPa}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.issuing_date
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDatePa ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDatePa))).format("DD/MM/YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }

                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isEarthquakeAffected ?
                                                <>
                                                    <hr className="mar_top_bottom_8" />
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                {
                                                                    profileDetailsLabel.earthquake_affected
                                                                }
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.certificate_number
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.certificateNoEqa}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.issuing_date
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateEqa ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateEqa))).format("DD/MM/YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto?.personalInfo?.isGraduateEmployee ?
                                                <>
                                                    <hr className="mar_top_bottom_8" />
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h5>
                                                                {
                                                                    profileDetailsLabel.graduate_employee
                                                                }
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.employee_number
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.employmentNoGpte}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="content-row clearfix">
                                                                <h6>
                                                                    {
                                                                        profileDetailsLabel.issuing_date
                                                                    }:
                                                                </h6>
                                                                <span>
                                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateGpte ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.issuingDateGpte))).format("DD/MM/YYYY")
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                                : <div className="advertisement_details_Eligibility border border-light">
                                    <div className="card">
                                        <div className="card-header">
                                            <span> {profileDetailsLabel.additional_reservation} </span>
                                        </div>
                                        <div className="card-body pad_top_bottom_8">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <strong>{profileDetailsLabel.additional_reservation}?</strong> : {profileDetailsLabel.BUTTON_NO}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            <br />

                            {/* physical mesurement */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.PHYSICAL_MESUREMENT} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="content-row clearfix">
                                                <h6>{profileDetailsLabel.HEIGHT}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.height}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="content-row clearfix">
                                                <h6>{profileDetailsLabel.WEIGHT}: </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.weight}
                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.chestDeflated ?
                                            <div className="col-md-3">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.CHEST_DEFLATED}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .chestDeflated
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            : ""
                                        }
                                        {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.chestInflated ?
                                            <div className="col-md-3">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.CHEST_INFLATED}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .chestInflated
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <br />

                            {/* caste details */}
                            <div className="card">
                                <div className="card-header">
                                    <span>
                                        {profileDetailsLabel.CASTE_CATEGORY_DETAILS}
                                    </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="content-row clearfix">
                                                <h6>{profileDetailsLabel.CATEGORY}: </h6>
                                                <span>
                                                    {getLookupOptionLabelNew(
                                                        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .categoryLookupId,
                                                        profileCreationAllLookupData
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" ?
                                            <>
                                                <div className="col-md-3 pad_0">
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != '332' ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.CASTE_CERTIFICATE_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .castCertificateNo
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""}
                                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId == '332' && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.ewsCertificateNumber ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.EWS_CASTE_CERTIFICATE_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .ewsCertificateNumber
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {profileDetailsLabel.ISSUING_DISTRICT}:
                                                        </h6>
                                                        <span>
                                                            {getDistrict(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.ccIssuingDistrictLookupId,
                                                                requiredDistricts
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" ?
                                                    <div className="col-md-3 pad_0">
                                                        <div className="content-row clearfix">
                                                            <h6>{profileDetailsLabel.ISSUING_DATE}: </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .castCertiIssuingDate
                                                                    ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castCertiIssuingDate))).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    : ""}
                                            </>
                                            : ""
                                        }
                                    </div>
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "324" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "325" ?
                                        <hr className="mar_top_bottom_8" />
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "324" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "325" ?
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != 323 || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale || (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 320 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 322) ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.DO_YOU_BELONG_TO_NON_CREAMY_LAYER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl
                                                                    ? "Yes"
                                                                    : "No"}
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.nclCertificateNo ?
                                                        <div className="content-row clearfix">
                                                            <h6>{profileDetailsLabel.NCL_CERT_NO}: </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .nclCertificateNo
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                <div className="col-md-4">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.latestNclIssueDate ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {profileDetailsLabel.ISSUING_DATE_NCL}:
                                                            </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .latestNclIssueDate
                                                                    ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.latestNclIssueDate))).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                            </div>
                                            {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl ?
                                                <div>
                                                    {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId == 321 ?
                                                        <div className="content-row clearfix pad_0">
                                                            <hr className="mar_top_bottom_8" />
                                                            &nbsp;&nbsp;<span className="errorText">* {profileDetailsLabel.NOT_CONSIDER_FOR_FEMALE_RESERVATION}: </span>
                                                        </div>
                                                        : ""}
                                                    {!getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgNcl && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId == 322 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale ?
                                                        <div className="content-row clearfix pad_0">
                                                            <hr className="mar_top_bottom_8" />
                                                            &nbsp;&nbsp;<span className="errorText">* {profileDetailsLabel.NOT_CONSIDER_FOR_FEMALE_RESERVATION}: </span>
                                                        </div>
                                                        : ""
                                                    }
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != 323 || getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgTransgenderFemale || (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 320 && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.genderLookupId != 322) ?
                                                        <div className="content-row clearfix">
                                                            &nbsp;&nbsp;<span className="errorText wordBreakCss">{profileDetailsLabel.YOU_WILL_NOT_BE_CONSIDERED_FOR_RESERVED_CATEGORY_POST}: </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                : ""}

                                        </>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" ?
                                        <hr className="mar_top_bottom_8" />
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "323" && getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.categoryLookupId != "332" ?
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DO_YOU_HAVE_CASTE_VALIDITY_CERTIFICATE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .flgCastValidityCert
                                                                ? "Yes"
                                                                : "No"}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 pad_0">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castValidityCertNo ?
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.CASTE_VALIDITY_CERTIFICATE_NO
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                        .castValidityCertNo
                                                                }
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                                <div className="col-md-4">
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castValidityCertIssueDate ?
                                                        <div className="content-row clearfix">
                                                            <h6>{profileDetailsLabel.ISSUING_DATE}: </h6>
                                                            <span>
                                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .castValidityCertIssueDate
                                                                    ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.castValidityCertIssueDate))).format("DD/MM/YYYY")
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                        : ""}
                                                </div>
                                            </div>
                                        </>
                                        : ""}
                                </div>
                            </div>
                            <br />

                            {/* Divyang details */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.Divyang_Details} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.ARE_YOU_DIVYANGJAN}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.DIVYANG_PERCENTAGE}:
                                                    </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .divyangPercentage
                                                        }
                                                    </span>
                                                </div>
                                            </div> : ""}
                                    </div>

                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.CATEGORY_OF_DISABILITIES
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getLookupOptionLabelNew(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .typeOfDisabilityLookupId,
                                                                profileCreationAllLookupData
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DATE_OF_ISSUE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.sadmCertificateDate ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.sadmCertificateDate))).format('DD/MM/YYYY') : ""
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DISABILITIES_SUB_CATEGORIES
                                                            }:
                                                        </h6>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.disabilitySubCategoriesLookupIds.map((ele, index) => {
                                                            if (ele) {
                                                                return (

                                                                    <span>

                                                                        {getLookupOptionLabelNew(ele, profileCreationAllLookupData)}
                                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.disabilitySubCategoriesLookupIds.length === index + 1 ?
                                                                            <span></span> : <span>,&nbsp;&nbsp;</span>}
                                                                    </span>
                                                                )
                                                            }
                                                        })

                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.TYPE_OF_DISABILITY_CERTIFICATE
                                                            }:
                                                        </h6>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.typeDisabilityCertificate === 1 ?
                                                            <span>{profileDetailsLabel.SADM}</span>
                                                            : getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.typeDisabilityCertificate === 2 ?
                                                                <span>{profileDetailsLabel.Swavalamban}</span>
                                                                : ""
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.DISABILITY_CERTIFICATE_NUMBER
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.sadmCertificateNumber
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {((getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDivyang) && ((getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid) || (getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udidEnrolmentNo))) ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {profileDetailsLabel.DO_YOU_POSSES_UNIQUE_DISABILITY_ID}:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid
                                                                ? "Yes"
                                                                : "No"}
                                                        </span>
                                                    </div>
                                                </div>
                                                {(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid) &&
                                                    <div className="col-md-6">
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.UDID_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udid
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                {(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udidEnrolmentNo) &&
                                                    <div className="col-md-6">
                                                        <div className="content-row clearfix">
                                                            <h6>
                                                                {
                                                                    profileDetailsLabel.UDID_ENROLLMENT_NUMBER
                                                                }:
                                                            </h6>
                                                            <span>
                                                                {
                                                                    getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.udidEnrolmentNo
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        : ""}
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.DISABILITY_SCRIBE_REQ}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityScribeReq
                                                        ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityScribeReq
                                                        : "---"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.SCRIBE_ARRANGED_BY}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.scribeArrangedBy
                                                        ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.scribeArrangedBy
                                                        : "---"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {profileDetailsLabel.DISABILITY_COMP_TIME}:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityCompTime
                                                        ? getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgDisabilityCompTime
                                                        : "---"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />

                            {/* sports details */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.SPORT_INFORMATION_LABEL.Sports_Details} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="col-md-4">
                                        <div className="content-row clearfix">
                                            <h6>
                                                {profileDetailsLabel.SPORT_INFORMATION_LABEL["ARE_YOU _MERITORIOUS_SPORTS_PERSON?"]}:
                                            </h6>
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                    .flgMetritoriousSportsman
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgMetritoriousSportsman ?
                                    <div className="qualification-table customStyle">
                                        <table className="table table-bordered" >
                                            <thead>
                                                <tr>
                                                    {profileDetailsLabel.sportsHeaderContent && profileDetailsLabel.sportsHeaderContent.slice(0, -2).map((ele, index) =>
                                                        <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody className='f12'>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.meritoriousSportsmanDtoList.map((ele, index) => {
                                                    if (ele) {
                                                        return (
                                                            <tr key={index}>
                                                                <td className="w-10 word-break text-center" >{index + 1}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.typeOfCompetitionLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.nameOfCompetitionLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.positionMedalLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{ele.tournamentStartDate ? dayjs(fromUTCDate(new Date(ele.tournamentStartDate))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{ele.tournamentEndDate ? dayjs(fromUTCDate(new Date(ele.tournamentEndDate))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{ele.certificateVerificationStatus === true ? "Yes" : "No"}</td>
                                                                <td className="word-break" >{getLookupOptionLabelNew(ele.sportsCertiVerificationCityLookupId, profileCreationAllLookupData)}</td>
                                                                <td className="word-break" >{ele.sportsCertiReportNo}</td>
                                                                <td className="word-break" >{ele.dateOfIssue ? dayjs(fromUTCDate(new Date(ele.dateOfIssue))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{ele.acknowledgementNumber}</td>
                                                                <td className="word-break" >{ele.dateOfSubmission ? dayjs(fromUTCDate(new Date(ele.dateOfSubmission))).format('DD/MM/YYYY') : ""}</td>
                                                                <td className="word-break" >{getEligibility(ele.eligibleForGroup)}</td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                                }
                                            </tbody>
                                        </table>
                                    </div> : ""}
                            </div>
                            <br />

                            {/* ex-serviceman details */}
                            <div className="card">
                                <div className="card-header">
                                    <span> {profileDetailsLabel.exServicemanInfo.Ex_service_Man} </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.exServicemanInfo.DOES_EX_SERVICEMAN_OF_THE_REGULAR
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgExArmedReg
                                                        ? "Yes"
                                                        : "No"}

                                                </span>
                                            </div>
                                        </div>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.SPORT_INFORMATION_LABEL.DIVISION_OF_ARMED_FORCES
                                                        }:
                                                    </h6>

                                                    <span>
                                                        {getExServiceManDivision(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.exServiceManDivision
                                                        )}
                                                    </span>
                                                </div>
                                            </div> : ""}
                                    </div>
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.DATE_OF_APPOINTMENT_IN_REGULAR_ARMED_FORCES
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateApptArmedRegular
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateApptArmedRegular))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo[
                                                                "DATE_OF_RETIREMEN_(DISCHARGE)_IN_REGULAR_ARMED_FORCES"
                                                                ]
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateRetireArmedRegular
                                                                ?
                                                                dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateRetireArmedRegular)))
                                                                    .format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.PERIOD_OF_SERVICE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {handleFromToDateSelection(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateApptArmedRegular, getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .dateRetireArmedRegular)
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.DISCHARGE_CERTIFICATE_NUMBER
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .dischargeCertificateNo
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.DATE_OF_DISCHARGE_FROM_ARMED_FORCES
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateDischargeArmedRegular ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.dateDischargeArmedRegular))).format('DD/MM/YYYY') : ""
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.THE_SERIAL_NUMBER_AUTHORITY_FOR_AGE_RELAXATION
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .ageRelaxCertiNo
                                                            }
                                                        </span>
                                                        <span className='floatRight'> {profileDetailsLabel.DATE} &nbsp;
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .ageRelaxCertiNo1
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.ageRelaxCertiNo1))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.ARE_YOU_DISABILITY_PENSION_HOLDER
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .flgDisabilityPensionHolder ?
                                                                    "Yes" : "No"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : ""}
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgExArmedReg ?
                                        <div>
                                            <hr className="mar_top_bottom_8" />
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.exServicemanInfo.HAVE_YOU_JOIN_STATE_GOVT
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .flgJoinedStateGovt ?
                                                                    "Yes" : "No"
                                                            }
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div> : ""}
                                </div>
                            </div>
                            <br />

                            {/* Government employee details */}
                            <div className="card">
                                <div className="card-header">
                                    <span>
                                        {
                                            profileDetailsLabel.GOV_MAH_EMPLOYEE.Government_of_Maharashtra_Employee_Details
                                        }
                                    </span>
                                </div>
                                <div className="card-body pad_top_bottom_8">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.GOV_MAH_EMPLOYEE.ARE_YOU_EMPLOYEE_GOVERMENT
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgGomEmployee
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgGomEmployee ?
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.GOV_MAH_EMPLOYEE.Sevaarth_ID
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .sevaarthId
                                                        }
                                                    </span>
                                                </div> : ""}
                                        </div>
                                    </div>
                                    <hr className="mar_top_bottom_8" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.GOV_MAH_EMPLOYEE.ARE_YOU_EMPLOYEE_BMC
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgBmcEmployee
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.GOV_MAH_EMPLOYEE.ARE_YOU_EMPLOYEE_BEST
                                                    }:
                                                </h6>
                                                <span>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                        .flgBestEmployee
                                                        ? "Yes"
                                                        : "No"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />

                            {/* orphan details */}
                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo ?
                                <div className="card">
                                    <div className="card-header">
                                        <span> {profileDetailsLabel.ORPHAN_DETAILS.Orphan_Detail} </span>
                                    </div>
                                    <div className="card-body pad_top_bottom_8">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.ORPHAN_DETAILS.DO_YOU_WANT_TO_TAKE_ADVANTAGE_FOR_ORPHAN_RESERVATION
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                            .flgOrphanReservation
                                                            ? "Yes"
                                                            : "No"}
                                                    </span>
                                                </div>
                                            </div>
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgOrphanReservation ?
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.ORPHAN_DETAILS.ORPHAN_TYPE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .orphanType
                                                            }
                                                        </span>
                                                    </div>
                                                </div> : ""}
                                        </div>
                                        <hr className="mar_top_bottom_8" />
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.flgOrphanReservation ?
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.ORPHAN_DETAILS.ORPHAN_CERTIFICATE_NO
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                    .orphanReservationCertiNo
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.ORPHAN_DETAILS.ORPHAN_CERTIFICATE_ISSUE_DATE
                                                            }:
                                                        </h6>
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo
                                                                .orphanCertiIssueDate
                                                                ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.orphanCertiIssueDate))).format("DD/MM/YYYY")
                                                                : ""}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div> : ""
                                        }
                                    </div>
                                </div>
                                : ""}
                            <br />

                            {/* {Address Information}                            } */}

                            {/* <div className="advertisement_details_Eligibility border border-light">
                                <label className="fw-bold">
                                    {profileDetailsLabel.profileadressinformation.ADD_INFO}
                                </label>
                                <hr />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <span>

                                                    {
                                                        profileDetailsLabel.profileadressinformation.PERMENANT_ADDRESS
                                                    }
                                                </span>
                                            </div>
                                            <div className="card-body pad_top_bottom_8">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_1
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantHouseNo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_2
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantBuildingName
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_3
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantRoadOrPo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.LANDMARK}: </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantLandmark
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.STATE_UNION_TERRITORY
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getStateName(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .permenantStateLookupId,
                                                            requiredStates
                                                        )}

                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.DISTRICT}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantDistrictLookupId ?
                                                        <span className="word-break">
                                                            {getDistrict(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .permenantDistrictLookupId,
                                                                requiredDistricts
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantDistrict
                                                            }
                                                        </span>
                                                    }

                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.TALUKA}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantTalukaLookupId ?
                                                        <span className="word-break">
                                                            {getTaluka(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.
                                                                    permenantTalukaLookupId,
                                                                requiredTaluka
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantTaluka
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.profileadressinformation.VILLAGE_CITY}:
                                                    </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantvillageCityLookupId ?
                                                        <span className="word-break">
                                                            {getVillage(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .permenantvillageCityLookupId,
                                                                requiredVillage
                                                            )}
                                                        </span>
                                                        :
                                                        <span className="word-break">
                                                            {
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantvillageCity
                                                            }
                                                        </span>
                                                    }
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.PINCODE}: </h6>
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.permenantPin}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="card">
                                            <div className="card-header">
                                                <span>
                                                    {
                                                        profileDetailsLabel.profileadressinformation.CORRESPONDANCE_ADDRESS
                                                    }
                                                </span>
                                            </div>
                                            <div className="card-body pad_top_bottom_8">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_1
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceHouseNo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_2
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceBuildingName
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.ADDRESS_LINE_3
                                                        }:
                                                    </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceRoadOrPo
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.LANDMARK}: </h6>
                                                    <span className="word-break">
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceLandmark
                                                        }
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.profileadressinformation.STATE_UNION_TERRITORY
                                                        }:
                                                    </h6>
                                                    <span>
                                                        {getStateName(
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondenceStateLookupId,
                                                            requiredStates
                                                        )}
                                                    </span>
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.DISTRICT}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceDistrictLookupId ?
                                                        <span className="word-break">
                                                            {getDistrict(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .correspondenceDistrictLookupId,
                                                                requiredDistricts
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceDistrict}
                                                        </span>
                                                    }
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.TALUKA}: </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceTalukaLookupId ?
                                                        <span className="word-break">
                                                            {getTaluka(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .correspondenceTalukaLookupId,
                                                                requiredTaluka
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceTaluka}
                                                        </span>
                                                    }
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {profileDetailsLabel.profileadressinformation.VILLAGE_CITY}:
                                                    </h6>
                                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceVillageCityLookupId ?
                                                        <span className="word-break">
                                                            {getVillage(
                                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                    .correspondenceVillageCityLookupId,
                                                                requiredVillage
                                                            )}
                                                        </span> :
                                                        <span className="word-break">
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo.correspondenceVillage}
                                                        </span>
                                                    }
                                                </div>
                                                <div className="content-row clearfix">
                                                    <h6>{profileDetailsLabel.profileadressinformation.PINCODE}: </h6>
                                                    <span>
                                                        {
                                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.addressInfo
                                                                .correspondencePin
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br /> */}
                        </>
                    }

                    {/* other information  */}
                    <div className="advertisement_details_Eligibility border border-light">
                        <div className="card">
                            <div className="card-header">
                                <span>{profileDetailsLabel.BLACKLIST_DETAILS}</span>
                            </div>
                            <div className="card-body pad_top_bottom_8">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>
                                                {
                                                    profileDetailsLabel.OTHER_INFORMATION[
                                                    "WHETHER_ANY_PROSECUTION_IS_PENDING_IN_ANY_COURT_OF_LAW_AGAINST_YOU?"
                                                    ]
                                                }:
                                            </h6>
                                            &ensp;
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo
                                                    .flgProsecutionCourtLaw
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>
                                                {
                                                    profileDetailsLabel.OTHER_INFORMATION[
                                                    "WHETHER_ANY_DISCIPLINARY_ACTION_HAS_BEEN_INITIATED_BY_GOVERNMENT?"
                                                    ]
                                                }:
                                            </h6>
                                            &ensp;
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo
                                                    .flgDispActionGovSemiGov
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <hr className="mar_top_bottom_8" />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>

                                                {
                                                    profileDetailsLabel.OTHER_INFORMATION[
                                                    "WHETHER_DISCIPLINARY_OR_ANY_OTHER_SIMILAR_ACTION_IS_INITIATED_INSTITUTION?"
                                                    ]
                                                }:
                                            </h6>
                                            &ensp;
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo
                                                    .flgBarcouncilInstitution
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>

                                                {
                                                    profileDetailsLabel.OTHER_INFORMATION[
                                                    "WAS_ANY_COURT_CASE_FILED_AGAINST_YOU?"
                                                    ]
                                                }:
                                            </h6>
                                            &ensp;
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo
                                                    .flgCourtCaseFilled
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr className="mar_top_bottom_8" />
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="content-row clearfix">
                                            <h6>
                                                {
                                                    profileDetailsLabel.OTHER_INFORMATION[
                                                    "WHETHER_DEBARRED_OR_BLACK_LISTED_FOR_EXAMINATION_OR_ANY_OTHER_ORGANISATIONS?"
                                                    ]
                                                }:
                                            </h6>
                                            &ensp;
                                            <span>
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo
                                                    .flgDebaredBlockListExam
                                                    ? "Yes"
                                                    : "No"}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.flgDebaredBlockListExam ?
                                            <div className="content-row clearfix">
                                                <h6>
                                                    {
                                                        profileDetailsLabel.OTHER_INFORMATION[
                                                        "DURATION"
                                                        ]
                                                    }:
                                                </h6>
                                                &ensp;
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.natureLookupId === 1 ?
                                                    <span>  {profileDetailsLabel.Permanent} </span>
                                                    : getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.natureLookupId === 2 ?
                                                        <span> {profileDetailsLabel.For_certain_period} </span>
                                                        : ""
                                                }
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.natureLookupId === 2 ?
                                    <div>
                                        <hr className="mar_top_bottom_8" />
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="content-row clearfix">
                                                    <h6>
                                                        {
                                                            profileDetailsLabel.OTHER_INFORMATION[
                                                            "FROM_DATE"
                                                            ]
                                                        }:
                                                    </h6>
                                                    &ensp;
                                                    <span>
                                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo
                                                            .debarredStartDate
                                                            ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.debarredStartDate))).format('DD/MM/YYYY') : ""}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.flgDebaredBlockListExam ?
                                                    <div className="content-row clearfix">
                                                        <h6>
                                                            {
                                                                profileDetailsLabel.OTHER_INFORMATION[
                                                                "TO_DATE"
                                                                ]
                                                            }:
                                                        </h6>
                                                        &ensp;
                                                        <span>
                                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.debarredEndDate ? dayjs(fromUTCDate(new Date(getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.otherInfo.debarredEndDate))).format('DD/MM/YYYY') : ""}
                                                        </span>
                                                    </div>
                                                    : ""}
                                            </div>
                                        </div>
                                    </div>
                                    : ""
                                }
                            </div>
                        </div>
                        <br />
                    </div>

                    {/* qualification_information */}
                    <div className="advertisement_details_Eligibility border border-light">
                        <label className="fw-bold">
                            {profileDetailsLabel.QUALIFICATION_INFO.QUAL_INFO}
                        </label>
                        <div className='customStyle'>
                            <table className="table table-bordered">
                                <thead>
                                    {(props.interviewPtLetterReportName === 'Profile Details') ?
                                        <tr>
                                            {profileDetailsLabel.QUALIFICATION_INFO && profileDetailsLabel.QUALIFICATION_INFO.qualificationHeaderContent && profileDetailsLabel.QUALIFICATION_INFO.qualificationHeaderContentWithProjectTitle.slice(0, -3).map((ele, index) =>
                                                <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                            )}
                                        </tr>

                                        :
                                        <tr>
                                            {profileDetailsLabel.QUALIFICATION_INFO && profileDetailsLabel.QUALIFICATION_INFO.qualificationHeaderContent && profileDetailsLabel.QUALIFICATION_INFO.qualificationHeaderContent.slice(0, -3).map((ele, index) =>
                                                <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                            )}
                                        </tr>

                                    }
                                </thead>
                                {(props.interviewPtLetterReportName === 'Profile Details') ?
                                    <tbody className='f12'>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.length > 0 ? (
                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList
                                                .sort((a, b) => {
                                                    return qualificationTypes.findIndex((type) => type.qualificationtypecode === a.qualificationtypecode)
                                                        - qualificationTypes.findIndex((type) => type.qualificationtypecode === b.qualificationtypecode);
                                                })
                                                .some(ele => !ele.flgDeleted) ? (
                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.map((ele, index) => (
                                                    !ele.flgDeleted ? (
                                                        <tr key={index}>
                                                            <td className="w-10 word-break text-center">{index + 1}</td>
                                                            <td className="word-break">{getQualificationType(ele.qualificationtypecode, requiredQualificationTypeCodes)}</td>
                                                            <td className="word-break">{getQualificationNameCode(ele.qualificationnamecode, requiredQualificationNameCode)}</td>
                                                            <td className="word-break">{getSubject(ele.subjectLookupId, requiredSubject)}</td>
                                                            <td className="word-break">{getUniversity(ele.universitycode, requiredQualificationUniversityCodes)}</td>
                                                            <td className="word-break">{ele.resultDate ? dayjs(fromUTCDate(new Date(ele.resultDate))).format('DD/MM/YYYY') : ""}</td>
                                                            <td className="word-break">{ele.attempts}</td>
                                                            <td className="word-break">{ele.percentageGrade}</td>
                                                            <td className="word-break">{ele.courseDurationMonths}</td>
                                                            <td className="word-break">{getLookupOptionLabelNew(ele.classGradeLookupId, profileCreationAllLookupData)}</td>
                                                            <td className="word-break">{getLookupOptionLabelNew(ele.modeLookupId, profileCreationAllLookupData)}</td>
                                                            <td className="word-break">{ele.registrationNumber}</td>
                                                            <td className="word-break">{ele.projectTitle}</td>
                                                            {(props && props.downloadProfileComponent) && (
                                                                <td className="word-break">{ele.updatedAt ? dayjs(fromUTCDate(new Date(ele.updatedAt))).format('DD/MM/YYYY') : ""}</td>
                                                            )}
                                                        </tr>
                                                    ) : null
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="14" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="14" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                    :
                                    <tbody className='f12'>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.length > 0 ? (
                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList
                                                .sort((a, b) => {
                                                    return qualificationTypes.findIndex((type) => type.qualificationtypecode === a.qualificationtypecode)
                                                        - qualificationTypes.findIndex((type) => type.qualificationtypecode === b.qualificationtypecode);
                                                })
                                                .some(ele => !ele.flgDeleted) ? (
                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.map((ele, index) => (
                                                    !ele.flgDeleted ? (
                                                        <tr key={index}>
                                                            <td className="w-10 word-break text-center">{index + 1}</td>
                                                            <td className="word-break">{getQualificationType(ele.qualificationtypecode, requiredQualificationTypeCodes)}</td>
                                                            <td className="word-break">{getQualificationNameCode(ele.qualificationnamecode, requiredQualificationNameCode)}</td>
                                                            <td className="word-break">{getSubject(ele.subjectLookupId, requiredSubject)}</td>
                                                            <td className="word-break">{getUniversity(ele.universitycode, requiredQualificationUniversityCodes)}</td>
                                                            <td className="word-break">{ele.resultDate ? dayjs(fromUTCDate(new Date(ele.resultDate))).format('DD/MM/YYYY') : ""}</td>
                                                            <td className="word-break">{ele.attempts}</td>
                                                            <td className="word-break">{ele.percentageGrade}</td>
                                                            <td className="word-break">{ele.courseDurationMonths}</td>
                                                            <td className="word-break">{getLookupOptionLabelNew(ele.classGradeLookupId, profileCreationAllLookupData)}</td>
                                                            <td className="word-break">{getLookupOptionLabelNew(ele.modeLookupId, profileCreationAllLookupData)}</td>
                                                            <td className="word-break">{ele.compulsorySubjects}</td>
                                                            <td className="word-break">{ele.optionalSubjects}</td>
                                                            {(props && props.downloadProfileComponent) && (
                                                                <td className="word-break">{ele.updatedAt ? dayjs(fromUTCDate(new Date(ele.updatedAt))).format('DD/MM/YYYY') : ""}</td>
                                                            )}
                                                        </tr>
                                                    ) : null
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="14" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="14" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                            </tr>
                                        )}
                                    </tbody>

                                }
                            </table>
                        </div>
                    </div>

                    {/* Council Details */}
                    <div className="advertisement_details_Eligibility border border-light">
                        <label className="fw-bold">
                            {profileDetailsLabel.COUNCIL_REG_DETAILS}
                        </label>
                        <div className='customStyle'>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        {profileDetailsLabel.councilDetailsTableHeader && profileDetailsLabel.councilDetailsTableHeader.map((ele, index) =>
                                            <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody className='f12'>
                                    {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.length > 0 ? (
                                        getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.some(ele => ele.councilId) ? (
                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.map((ele, index) => (
                                                ele.councilId ? (
                                                    <tr key={index}>
                                                        <td className="word-break">{index + 1}</td>
                                                        <td className="word-break">{ele.councilId}</td>
                                                        <td className="word-break">{ele.councilRegistrationDate}</td>
                                                        <td className="word-break">{ele.councilRegistrationNumber}</td>
                                                        <td className="word-break">{ele.councilRenewalDate}</td>
                                                    </tr>
                                                ) : null
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                            </tr>
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* showPublicationTable */}
                    <>
                        <hr />
                        <div className="advertisement_details_Eligibility border border-light">
                            <label className="fw-bold">
                                {profileDetailsLabel.PUBLICATION_DETAILS}
                            </label>
                            <div className='customStyle'>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            {profileDetailsLabel.publicationQualificationNewHeaderContent && profileDetailsLabel.publicationQualificationNewHeaderContent.slice(0, -2).map((ele, index) =>
                                                <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody className='f12'>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.length > 0 ? (
                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList
                                                .sort((a, b) => {
                                                    return qualificationTypes.findIndex((type) => type.qualificationtypecode === a.qualificationtypecode)
                                                        - qualificationTypes.findIndex((type) => type.qualificationtypecode === b.qualificationtypecode);
                                                })
                                                .some(ele => !ele.flgDeleted && ele.qualificationtypecode === "Pb") ? (
                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.qualificationInfoList.map((ele, index) => (
                                                    !ele.flgDeleted && ele.qualificationtypecode === "Pb" ? (
                                                        <tr key={index}>
                                                            <td className="w-10 word-break text-center">{++publilcationTableCount}</td>
                                                            {/* <td className="word-break ">{getQualificationType(ele.qualificationtypecode, requiredQualificationTypeCodes)}</td> */}
                                                            <td className="word-break ">{getQualificationNameCode(ele.qualificationnamecode, requiredQualificationNameCode)}</td>
                                                            <td className="word-break">{ele.publicationQualificationInfo && nameOfIndexingBodies(ele.publicationQualificationInfo.indexingBodyLookupId, nameOfIndexingBodiesList)}</td>
                                                            <td className="word-break">{ele.publicationQualificationInfo && articleType(ele.publicationQualificationInfo.articleTypeLookupId, getPublicationArticleTypeList)}</td>
                                                            <td className="word-break">{flgPublicationFirstAuthor(ele.flgPublicationFirstAuthor, BOOLEAN_OPTION)}</td>
                                                            <td className="word-break">{authorType(ele.publicationAuthorType, AUTHOR_TYPES)}</td>
                                                            <td className="word-break">{ele.publicationJournalDetails}</td>
                                                            <td className="word-break">{ele.publicationYear}</td>
                                                            <td className="word-break">{ele.flgImpactIndex2Or0OrMore ? "Yes" : "No"}</td>
                                                            <td className="word-break">{ele.publicationPaperTitle}</td>
                                                            <td className="word-break">{ele.publicationQualificationInfo && dayjs(ele.publicationQualificationInfo.publicationAcceptanceDate).format(profileDetailsLabel.DATE_FORMAT)}</td>
                                                            <td className="word-break">{ele.publicationQualificationInfo && dayjs(ele.publicationQualificationInfo.publicationPublishedDate).format(profileDetailsLabel.DATE_FORMAT)}</td>
                                                        </tr>
                                                    ) : null
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="15" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="15" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>

                    {/* experience information */}
                    <div className="advertisement_details_Eligibility border border-light">
                        <label className="fw-bold">
                            {profileDetailsLabel.EXPERINCE_INFO.EXPERIENCE_INFO_LABEL}
                        </label>
                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.isExperienced ?
                            <div className="qualification-table customStyle">
                                <table className="table table-bordered">
                                    <thead>
                                        {(props.interviewPtLetterReportName === 'Application Recommendation') ?
                                            <tr>
                                                {profileDetailsLabel.EXPERINCE_INFO.experienceHeaderContent.slice(0, -3).map(
                                                    (ele, index) =>
                                                        <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                                )}
                                            </tr>
                                            :
                                            <tr>
                                                {profileDetailsLabel.EXPERINCE_INFO.experienceNewHeaderContent.slice(0, -3).map(
                                                    (ele, index) =>
                                                        <th scope="col" key={index} className='theadBgColor'>{ele}</th>
                                                )}
                                            </tr>
                                        }
                                    </thead>
                                    <tbody className='f12'>
                                        {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.experienceInfoList.length > 0 ? (
                                            getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.experienceInfoList.some(ele => !ele.flgDeleted) ? (
                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.experienceInfoList.map((ele, index) => (
                                                    !ele.flgDeleted ? (
                                                        <tr key={index}>
                                                            <td className="w-10 word-break text-center">{index + 1}</td>
                                                            <td className="word-break">{ele.officeName}</td>
                                                            <td className="word-break">{ele.designation}</td>
                                                            <td className="word-break">{getLookupOptionLabelNew(ele.apointmentNatureLookupId, profileCreationAllLookupData)}</td>
                                                            <td className="word-break">{getLookupOptionLabelNew(ele.jobNatureLookupId, profileCreationAllLookupData)}</td>

                                                            {(props.interviewPtLetterReportName === 'Application Recommendation') &&
                                                                <td className="word-break">{getDropdownOptionLabel(ele.fullTimeLookupId, FULLTIME_OPTION)}</td>}

                                                            <td className="word-break">{ele.payScale}</td>
                                                            <td className="word-break">{ele.gradePay}</td>
                                                            <td className="word-break">{ele.monthlyGrossSalary}</td>
                                                            <td className="word-break">{ele.employmentFrom ? dayjs(fromUTCDate(new Date(ele.employmentFrom))).format('DD/MM/YYYY') : ""}</td>
                                                            <td className="word-break">{ele.employmentTo ? dayjs(fromUTCDate(new Date(ele.employmentTo))).format('DD/MM/YYYY') : dayjs().format('DD/MM/YYYY')}</td>
                                                            <td className="word-break">{ele.employmentTo ? ele.expYears : handleFromToDateSelectionForExp(
                                                                dayjs(fromUTCDate(new Date(ele.employmentFrom))).format(),
                                                                dayjs().format()
                                                            ).expYears}</td>
                                                            <td className="word-break">{ele.employmentTo ? ele.expMonths : handleFromToDateSelectionForExp(
                                                                dayjs(fromUTCDate(new Date(ele.employmentFrom))).format(),
                                                                dayjs().format()
                                                            ).expMonths}</td>
                                                            <td className="word-break">{ele.employmentTo ? ele.expDays : handleFromToDateSelectionForExp(
                                                                dayjs(fromUTCDate(new Date(ele.employmentFrom))).format(),
                                                                dayjs().format()
                                                            ).expDays}</td>
                                                            {(props.interviewPtLetterReportName === 'Application Recommendation') &&
                                                                <td className="word-break">{getDropdownOptionLabel(ele.flgMpscSelection, BOOLEAN_OPTION)}</td>}
                                                            {props && props.downloadProfileComponent && (
                                                                <td className="word-break">{ele.updatedAt ? dayjs(fromUTCDate(new Date(ele.updatedAt))).format('DD/MM/YYYY') : ""}</td>
                                                            )}
                                                        </tr>
                                                    ) : null
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="16" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="16" className="text-center">{profileDetailsLabel.NO_DATA_TO_DISPLAY}</td>
                                            </tr>
                                        )}
                                    </tbody>

                                </table>
                            </div>
                            :
                            <div className="card">
                                <div className="card-body pad_top_bottom_8">
                                    <div className="content-row clearfix">
                                        <h6>
                                            {profileDetailsLabel.EXPERINCE_INFO.ARE_YOU_HAVING_EXPERIENCE}:
                                        </h6>
                                        &ensp;
                                        <span>
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.isExperienced ? "Yes" : "No"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                        }
                    </div>

                    {/*Appointing Authorities */}
                    {(applicationPostData && applicationPostData.length > 0) &&
                        <div className="advertisement_details_Eligibility border border-light">
                            <label className="fw-bold">
                                {profileDetailsLabel.APPOINTING_AUTHORITIES}
                            </label>
                            {applicationPostData.length > 0 &&
                                applicationPostData.map((ele, ind) => {
                                    return (
                                        <div className="row" key={ind}>
                                            <div className="col-md-12 tableCss mt-n4">
                                                <br />
                                                <hr className="mar_top_bottom_8" />
                                                <label className="fw-bold">
                                                    {profileDetailsLabel.POST_NAME} {ele.postName}
                                                </label>
                                                {ele.preferredAppointingAuthorities && ele.preferredAppointingAuthorities.mumbai && ele.preferredAppointingAuthorities.mumbai.length > 0 &&
                                                    <table className="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" key="0">{profileDetailsLabel.MUMBAI_APPOINTING_AUTHORITIES} </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="f12">
                                                            {ele.preferredAppointingAuthorities && ele.preferredAppointingAuthorities.mumbai && ele.preferredAppointingAuthorities.mumbai.map((e, indx) => (

                                                                <tr key={indx}>
                                                                    <td className="word-break ">{e.label}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                }
                                                {ele.preferredAppointingAuthorities && ele.preferredAppointingAuthorities.outsideMumbai && ele.preferredAppointingAuthorities.outsideMumbai.length > 0 &&
                                                    <table className="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" key="0">{profileDetailsLabel.OTHER_THAN_MUMBAI_APPOINTING_AUTHORITIES}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="f12">
                                                            {ele.preferredAppointingAuthorities && ele.preferredAppointingAuthorities.outsideMumbai && ele.preferredAppointingAuthorities.outsideMumbai.map((e, indx) => (
                                                                <tr key={indx}>
                                                                    <td className="word-break ">{e.label}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                }
                                            </div>
                                        </div>);
                                })
                            }
                        </div>
                    }

                    {/* Additional Questions*/}

                    <hr className="mar_top_bottom_8" />
                    {additionalQuestionsArr && additionalQuestionsArr.length > 0 ?
                        <div className="card ">
                            <div className="card-header">
                                <span> {profileDetailsLabel.ADDITIONAL_QUESTIONS} </span>
                                <span className=" float-end"> {profileDetailsLabel.ANSWER} </span>
                            </div>
                            <div className="card-body pad_top_bottom_8">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="content-row clearfix">
                                            {additionalQuestionsArr && additionalQuestionsArr.map((ele, i) => (
                                                additionalAnswersDetails(ele.id) && <>
                                                    <div key={i} className="content-row clearfix pt-0 mt-0">
                                                        <label>{ele.question}</label>
                                                        <div className="float-end">
                                                            <label>
                                                                {additionalAnswersDetails(ele.id)}
                                                            </label>
                                                        </div><br />
                                                    </div>&nbsp;&nbsp;&nbsp;
                                                </>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ""}

                    {/* Declaration*/}
                    <div className="card advertisement_details_Eligibility border-light">
                        <div className="card-header">
                            {profileDetailsLabel.Declaration}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-9">
                                    <h6>I&nbsp;
                                        <strong>
                                            {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo ?
                                                getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.personalInfo.englishFullName
                                                :
                                                "CANDIDATE FULL NAME"
                                            }&nbsp;
                                        </strong>
                                        {profileDetailsLabel.DECLARATION}
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <div className="content-row">
                                        <h6>{profileDetailsLabel.UPDATE_ON}  </h6>
                                        <span>
                                            {getApplicationDetailsForApplicationProfileReport && getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.updatedAt
                                                ? dayjs(
                                                    getApplicationDetailsForApplicationProfileReport.application.updatedAt
                                                ).format(profileDetailsLabel.DATE_FORMAT)
                                                : ""
                                            }
                                        </span><br />
                                        <h6>{profileDetailsLabel.Location}</h6>
                                        <span>
                                            {
                                                getApplicationDetailsForApplicationProfileReport.application && getApplicationDetailsForApplicationProfileReport.application.location
                                            }
                                        </span>
                                    </div><br />
                                    {getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.signature ?
                                        <img
                                            src={getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto && getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.signature ? `data:image/png;base64,${getApplicationDetailsForApplicationProfileReport.profileInfoDisplayDto.signature}` : ""}
                                            width="130" height="60" />
                                        :
                                        <img
                                            alt='/#'
                                            className="img-profile"
                                            src={`data:image/png;base64,${defaultImage}`}
                                            width="130" height="auto" />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>

    )
}

export default ProfileApplicationReport;
